import Layout from '../../components/Layout.jsx'
import { DataTable } from '../../components/DataTable.jsx'
import { useApp } from '../../context/AppContext.jsx'
import { getGeo } from '../../db/api.js'
import { useApiData } from '../../hooks/useApiData.js'

export default function Geo() {
  const { period } = useApp()
  const { data, loading, error } = useApiData(
    () => getGeo(period.start, period.end),
    [period.start, period.end],
    { initialData: [] }
  )

  const columns = [
    { key: 'region', label: 'Regiao', width: 180 },
    { key: 'city', label: 'Cidade', width: 180 },
    { key: 'impressions', label: 'Impressoes', format: 'number', align: 'right', width: 130 },
    { key: 'clicks', label: 'Cliques', format: 'number', align: 'right', width: 110 },
    { key: 'ctr', label: 'CTR', format: 'percent', align: 'right', width: 100 },
    { key: 'cost', label: 'Investimento', format: 'currency', align: 'right', width: 150 },
  ]

  return (
    <Layout
      breadcrumb={[{ label: 'Analytics' }, { label: 'Localizacao' }]}
      title="Performance por Localizacao"
      showPeriod
    >
      <div className="section-card">
        <div className="sc-head">
          <div className="card-title-group">
            <span className="t-label">Analytics</span>
            <span className="t-title" style={{ fontSize: 17 }}>Geografia de desempenho</span>
          </div>
        </div>
        <div style={{ padding: '0 24px 24px' }}>
          {error ? (
            <div className="empty" style={{ padding: 32 }}>
              <div className="empty-title">Nao foi possivel carregar a analise geografica</div>
              <div className="empty-desc">{error}</div>
            </div>
          ) : (
            <DataTable
              columns={columns}
              data={data || []}
              loading={loading}
              emptyText="Nenhum dado geografico encontrado"
              pagination
              pageSize={15}
              striped={false}
            />
          )}
        </div>
      </div>
    </Layout>
  )
}
